module.exports = __webpack_public_path__ + "static/media/122.04d55be8.svg";